import { select, takeEvery } from 'redux-saga/effects';

import * as authSelectors from '@redux/reducers/auth';
import { store } from '@redux/storeConfig/store';
import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';

import * as actions from '../actions';
import * as schemas from '../schemas';
import {
  deleteDistributionChannelService,
  getDistributionChannelsListService,
  saveDistributionChannelService
} from '../services';
import * as types from '../types';

/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                  */
/* -------------------------------------------------------------------------- */
function* fetchDistributionChannelsList(action: any) {
  const {
    operatorId: filterOperatorId,
    organizationId: filterOrganizationId,
    divisionId,
    subdivisionId
  } = action.payload;
  const { operatorId, organizationId } = yield select(authSelectors.getAuthUserMembershipFilters, {
    filterOperatorId,
    filterOrganizationId
  });

  getDistributionChannelsListService(
    { operatorId, organizationId, divisionId, subdivisionId },
    {
      successAction: (response: any) => {
        const resultData = response.data.map((result: any) => camelcaseKeys(result));
        const {
          entities: { distributionChannels },
          result
        } = normalize(resultData, schemas.distributionChannels);
        store.dispatch(
          actions.completeFetchingDistributionChannels(distributionChannels ?? {}, result)
        );
      },
      errorAction: (error: any) => {
        store.dispatch(actions.failFetchingDistributionChannels(error));
      }
    }
  );
}

export function* watchFetchDistributionChannelsList() {
  yield takeEvery(types.DISTRIBUTION_CHANNELS_FETCH_STARTED, fetchDistributionChannelsList);
}

/* -------------------------------------------------------------------------- */
/*                                    SAVE                                     */
/* -------------------------------------------------------------------------- */
function* saveDistributionChannel(action: any) {
  const distributionChannel = action.payload;
  saveDistributionChannelService(distributionChannel, {
    successAction: (response: any) => {
      const saved = camelcaseKeys(response.data.distributionChannel);
      store.dispatch(actions.completeSavingDistributionChannel(saved));
    },
    errorAction: (error: any) => {
      store.dispatch(actions.failSavingDistributionChannel(error));
    }
  });
}

export function* watchSaveDistributionChannelStarted() {
  yield takeEvery(types.DISTRIBUTION_CHANNEL_SAVE_STARTED, saveDistributionChannel);
}

/* -------------------------------------------------------------------------- */
/*                                   DELETE                                    */
/* -------------------------------------------------------------------------- */
function* deleteDistributionChannel(action: any) {
  const { distributionChannelId, name } = action.payload;
  deleteDistributionChannelService(
    { distributionChannelId, name },
    {
      successAction: () => {
        store.dispatch(actions.completeDeletingDistributionChannel(distributionChannelId));
      },
      errorAction: (error: any) => {
        store.dispatch(actions.failDeletingDistributionChannel(error));
      }
    }
  );
}

export function* watchDeleteDistributionChannelStarted() {
  yield takeEvery(types.DISTRIBUTION_CHANNEL_DELETE_STARTED, deleteDistributionChannel);
}
